import { create } from 'zustand'
import { persist, devtools } from 'zustand/middleware'
import { getFCMToken } from './fcm/getFcmToken'

export interface MesagingTokenStore {
  messagingToken?: string
  setMessagingToken: (token?: string) => void
  ensureToken: () => Promise<string | undefined>
}

export const useMessagingToken = create<MesagingTokenStore>()(
  devtools(
    persist(
      set => ({
        messagingToken: undefined,
        setMessagingToken: (token?: string) => set({ messagingToken: token }),
        ensureToken: async () => {
          try {
            const token = await getFCMToken()
            set({ messagingToken: token })
            return token
          } catch (e) {
            console.error('Failed to refresh FCM token', e)
            return undefined
          }
        },
      }),
      {
        name: '2meters-messaging-token',
        partialize: state => ({ messagingToken: state.messagingToken }),
      }
    )
  )
)
